import React from 'react';
import NavMenu from './NavMenu';
import mobileLogo from '../../images/logo-icon-agc-mobile.png';
import logo from '../../images/logo-agc.png';

const Sidebar = () => {
    return (
        <aside className="col main-sidebar bg-white px-0 overflow-auto">
            <div className="logo-wrap d-none d-lg-block">
                <img src={logo} alt="Alex Gamble" className="img-fluid mx-auto open-side-logo" />
                <img src={mobileLogo} alt="Alex Gamble" className="img-fluid mx-auto close-side-logo" />
            </div>           
            <NavMenu />
        </aside>
    );
};
export default Sidebar;